import React from "react";
import PropTypes from "prop-types";
import flatten from "lodash/flatten";
import { formatComma, formatPerc } from "../utils/dataHelpers/formatters";
import H from "./H";

const Summary = ({ data }) => {
  // const
  let flatData = data.map((datum) => datum.data);
  flatData = flatten(flatData);
  const countOutsideRange = flatData.reduce((accum, currentVal) => {
    const { workloadVarCounty } = currentVal;
    if (workloadVarCounty < -0.15 || workloadVarCounty > 0.15) {
      const count = accum + 1;
      return count;
    }
    return accum;
  }, 0);

  const totalJudges = flatData.length;
  const percOutsideRange = formatPerc(
    (countOutsideRange / totalJudges) * 100,
    0
  );

  return (
    <div className="summary__container">
      In 2019, <H>{formatComma(countOutsideRange)}</H> of{" "}
      <H>{formatComma(totalJudges)}</H> judges in the above counties had
      workloads outside the range recommended by the courts. That represents{" "}
      <H>{percOutsideRange}</H> of all judges in those counties.
    </div>
  );
};

Summary.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      categoryVal: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    })
  ).isRequired,
};

export default Summary;
